<template lang="pug">
  shListData(title="Colors History" resolver="colorsHistory" keyData="_id" component="shColor" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'ColorsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/color/ColorsHistory.vue